var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.MESSAGE)?_c('MyMessage'):_vm._e(),(_vm.LOADING)?_c('TheLoading'):_vm._e(),(_vm.LOGIN)?_c('LoginPopup'):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }